// src/components/InputDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";

export default function InputDialog({
  open,
  title = "Enter Value",
  message = "",
  placeholder = "",
  confirmText = "OK",
  cancelText = "Cancel",
  onConfirm = () => {},
  onCancel = () => {},
}) {
  const [value, setValue] = React.useState("");

  // Reset input when dialog opens
  React.useEffect(() => {
    if (open) setValue("");
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          minWidth: 420,   // ⭐ Wider dialog
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, fontSize: "18px" }}>
        {title}
      </DialogTitle>

      <DialogContent sx={{ mt: 1 }}>
        {message && (
          <Typography sx={{ mb: 1, fontSize: "14px", color: "#555" }}>
            {message}
          </Typography>
        )}

        <TextField
          fullWidth
          size="medium"
          autoFocus
          placeholder={placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{
            mt: 1,
            "& .MuiInputBase-input": {
              padding: "10px 12px",
            },
          }}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button variant="contained" onClick={() => onConfirm(value)}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
